import { render } from "./LandlordLogin.vue?vue&type=template&id=dc31b056&scoped=true"
import script from "./LandlordLogin.vue?vue&type=script&lang=js"
export * from "./LandlordLogin.vue?vue&type=script&lang=js"

import "./LandlordLogin.vue?vue&type=style&index=0&id=dc31b056&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc31b056"]])

export default __exports__